import { render } from "./PerformanceMarketingCampaignTip.vue?vue&type=template&id=0a461276"
import script from "./PerformanceMarketingCampaignTip.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingCampaignTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__